module.exports = __webpack_public_path__ + "static/media/Tamsin_Crane_ID.c34dc3ea.jpg";